// extracted by css-extract-rspack-plugin
module.exports =  {"add":"FormAdd__add--O_Zgz","addFixed":"FormAdd__addFixed--ZDfTT FormAdd__add--O_Zgz"};